export default __webpack_public_path__ + "static/media/vision.ac9c498f.svg";